import axios from "axios";
import { GetCouponsService } from "types/services";
import { getToken } from "utils/token";

const allCoupons: GetCouponsService = async (payload) => {
    const { data } = await axios.get(`coupons?page=${payload?.page}&limit=${payload?.limit}`, { headers: { Authorization: getToken() }, });
    return data
}

export default allCoupons